export default "__VITE_ASSET__C00HFLNJ__"